import * as React from 'react';

import BaseInsightsPage from 'modules/insights/pages/BaseInsightsPage';

import InsightsReportsReportPageCollabaryInstagram from './instagram/InsightsReportsReportPageCollabaryInstagram';

import { __t, applyTranslations } from 'utils/language';

import type { LineGraphEChartsObject, LocationWindow, Organization } from 'types';
import type {
  GeneralVoidFunction,
  Report,
  ReportType,
  ReportUpdateCallback
} from 'modules/insights/reports/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('modules/insights/reports/shared/insights-reports-shared.i18n.json'));

type Props = {
  organization: Organization,
  location: LocationWindow,
  brandProfileId: number | undefined | null,
  report: Report,
  reportId: number,
  reportType: ReportType,
  isReportSaved: boolean,
  graphInstance: LineGraphEChartsObject | undefined | null,
  isAnalysisDownloading: boolean,
  onRenderBreadcrumbs: () => React.ReactNode,
  onRenderPageHeader: () => React.ReactNode,
  onRenderReportHeader: (onUpdateReport: ReportUpdateCallback, onDownloadReport?: GeneralVoidFunction | null) => React.ReactNode,
  onReportSavedText: () => void,
  onChartInstanceCallback: (echartsInstance: LineGraphEChartsObject) => void
};

const SHARED_MSG_KEY = 'insights_reports_shared';

class InsightsReportsReportPageCollabary extends React.PureComponent<Props> {
  renderInstagram(): React.ReactNode {
    const {
      location,
      brandProfileId,
      report,
      reportId,
      reportType,
      isReportSaved,
      isAnalysisDownloading,
      graphInstance,
      onRenderBreadcrumbs,
      onRenderPageHeader,
      onRenderReportHeader,
      onReportSavedText,
      onChartInstanceCallback
    } = this.props;

    return (
      <InsightsReportsReportPageCollabaryInstagram
        location={location}
        brandProfileId={brandProfileId}
        report={report}
        reportId={reportId}
        reportType={reportType}
        isReportSaved={isReportSaved}
        isAnalysisDownloading={isAnalysisDownloading}
        graphInstance={graphInstance}
        onRenderBreadcrumbs={onRenderBreadcrumbs}
        onRenderPageHeader={onRenderPageHeader}
        onRenderReportHeader={onRenderReportHeader}
        onReportSavedText={onReportSavedText}
        onChartInstanceCallback={onChartInstanceCallback}
      />
    );
  }

  render(): React.ReactNode {
    const { organization } = this.props;

    return (
      <BaseInsightsPage
        documentTitle={__t(`${SHARED_MSG_KEY}.document_title`)}
        organization={organization}
      >
        <div className="insights-reports-report-page insights-reports-report-page-collabary">
          {this.renderInstagram()}
        </div>
      </BaseInsightsPage>
    );
  }
}

export default InsightsReportsReportPageCollabary;
